export enum UsageAggregationFunction {
  SUM = 'SUM',
  // AVG = 'AVG',
  // COUNT = 'COUNT',
  // MAX = 'MAX',
  // MIN = 'MIN',
}
